import { useEffect, useState, useMemo } from "react";
import {Form,Button} from 'reactstrap';
import { APILA } from "../../../../../../../config/apila";
import { APIMS } from "../../../../../../../config/apims";
import Modal from 'react-bootstrap/Modal';
import { useMutation } from "react-query";
import "bulma/css/bulma.css";
import LoaderAction from "../../../../../../Loader/LoaderHome";
import ToastError from "../../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../../NotificationToast/ToastSuccess";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faTrash } from '@fortawesome/free-solid-svg-icons';
import Swal from "sweetalert2";
  
export default function ModalUpdatePrilaku(props) {
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const ascending = 1;

  const safeValue = (value) => value ?? "";
  
  const fetchParams = useMemo(
      () => ({
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
      }),
      [token]
    );

  const id_user = localStorage.getItem("id_admin")?.replace(/[|&;$%@"<>()+,]/g, "");

  const [openIndikator, setOpenIndikator] = useState(false);
  const [selectedIndikatorLabel, setSelectedIndikatorLabel] = useState("");

  // Loader select
  const [loadingTA, setLoadingTA] = useState(false);
  const [loadingDimensi, setLoadingDimensi] = useState(false);
  const [loadingElement, setLoadingElement] = useState(false);
  const [loadingIndikator, setLoadingIndikator] = useState(false);
 
  // Data
  const [getDataTA, setGetDataTA] = useState([]);
  const [getDataDimensi, setGetDataDimensi] = useState([]);
  const [getElement, setGetElement] = useState([]);
  const [getIndikator, setGetIndikator] = useState([]);

  const [form, setForm] = useState({
    ysb_semester_id: "",
    ysb_dimensi_id:"",
    ysb_element_id: "",
    ysb_sub_element_id: "",
    name_sub_element:"",
    description_anomaly: "",
    user_id:"",
  });

  useEffect(() => {
    setForm({
    ...form,
      ysb_semester_id: safeValue(props?.dataUpdate?.ysb_semester_id),
      ysb_dimensi_id: safeValue(props?.dataUpdate?.ysb_dimensi_id),
      ysb_element_id: safeValue(props?.dataUpdate?.ysb_element_id),
      ysb_sub_element_id: safeValue(props?.dataUpdate?.ysb_sub_element_id),
      name_sub_element: safeValue(props?.dataUpdate?.name_sub_element),
      description_anomaly: safeValue(props?.dataUpdate?.description_anomaly),
      user_id: safeValue(props?.dataUpdate?.user_id),
    });
  },[props])

  const GetResponseTA = async () => {
      setLoadingTA(true);
      try {
        // const response = await APILA.get(
        //   `/api/access/semesters?page=1&limit=1000&ascending=${ascending}&search=`,
        //   fetchParams
        // );

        const response = await APIMS.get(
          `/api/access/semesters?page=1&limit=1000&ascending=${ascending}&search=`,
          fetchParams
        );

        if (response?.status === 200) {
          setGetDataTA(response?.data?.data || []);
        }
      } catch (error) {
        ToastError.fire({
          icon: "error",
          title: error.response?.data?.message || "Gagal memuat data",
        });
      } finally {
        setLoadingTA(false);
      } ;
  } 

  useEffect(() => {
      GetResponseTA();
  }, [])

  const GetResponseDimensi = async () => {
      const response = await APILA.get(
        `/api/access/dimensis?page=1&limit=1000&ascending=${ascending}&search=`,
        fetchParams
      );
    
     if (response?.status === 200) {
        const dims = (response.data.data || []).filter((d) => d.status === 1);
        setGetDataDimensi(dims);
      }
  } 

  useEffect(() => {
      GetResponseDimensi();
  }, [])

  

  const GetResponseElement = async () => {
      setLoadingElement(true);
      try {
        const response = await APILA.get(
          `/api/access/elements/dimensis?page=1&limit=1000&ascending=${ascending}&search=&ysb_dimensi_id=${form?.ysb_dimensi_id}`,
          fetchParams
        );

        if (response?.status === 200) {
          setGetElement(response?.data?.data || []);
        }
      } catch (error) {
        ToastError.fire({
          icon: "error",
          title: error.response?.data?.message || "Gagal memuat data",
        });
      } finally {
        setLoadingElement(false);
      } 
  }
  
  useEffect(() => {
    if (form?.ysb_dimensi_id) {
      GetResponseElement();
    } else {
      setGetElement([]);
    }
  }, [form?.ysb_dimensi_id]);

  const GetResponseIndikator = async () => {
      setLoadingIndikator(true);
      try {
        const response = await APILA.get(
          `/api/sub-elements?page=1&limit=1000&ascending=${ascending}&search=&id_element=${form?.ysb_element_id}`,
          fetchParams
        );

        if (response?.status === 200) {
          setGetIndikator(response?.data?.data || []);
        }
      } catch (error) {
        ToastError.fire({
          icon: "error",
          title: error.response?.data?.message || "Gagal memuat data",
        });
      } finally {
        setLoadingIndikator(false);
      } 
  }

  useEffect(() => {
    if (form?.ysb_element_id) {
      GetResponseIndikator();
    } else {
      setGetIndikator([]);
    }
  }, [form?.ysb_element_id]);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = useMutation(async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await APILA.put(
        "api/config-anomalys/update-all",
        {
          ysb_semester_id: form?.ysb_semester_id,
          ysb_sub_element_id: form?.ysb_sub_element_id,
          description_anomaly: form?.description_anomaly,
          user_id: id_user,
        },
        fetchParams
      );

      if (response.status === 200) {
        ToastSuccess.fire({
          icon: "success",
          title: response.data.message,
        });

        props.GetResponseData();
        props.onHide();
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error.response?.data?.message || "Gagal memperbarui data",
      });
    } finally {
      setIsSubmitting(false);
    }
  });


  const deleteById = () => {
  Swal.fire({
    title: "Apakah Kamu Yakin?",
    text: "Data yang dihapus tidak bisa dikembalikan",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Ya, Hapus",
    cancelButtonText: "Batal",
    showLoaderOnConfirm: true,
    allowOutsideClick: () => !Swal.isLoading(),

    preConfirm: async () => {
      try {
        const response = await APILA.delete(
          "/api/config-anomalys/delete-all",
          {
            ...fetchParams,
            data: {
              ysb_semester_id: form?.ysb_semester_id,
              ysb_sub_element_id: form?.ysb_sub_element_id,
              description_anomaly: form?.description_anomaly,
              user_id: id_user,
            },
          }
        );

        if (response?.data?.error) {
          throw new Error(response?.data?.message);
        }

        return response;
      } catch (error) {
        Swal.showValidationMessage(
          error?.response?.data?.message || error?.message || "Gagal menghapus data"
        );
      }
    },
  }).then((result) => {
    if (result.isConfirmed) {
      ToastSuccess.fire({
        icon: "success",
        title: result?.value?.data?.message || "Data berhasil dihapus",
      });
      props.GetResponseData();
      props.onHide();
    }
  });
};





  return (
    <div className="modal">
    {loading && <LoaderAction/>}

     <Modal {...props} size="md" aria-labelledby="contained-modal-title-vcenter" centered backdrop="static" keyboard={false}>  
    
            <div className="d-flex header-modal">
                <h5>Update Perilaku</h5>
            
                <div className="ml-auto ">
                    {/* <FontAwesomeIcon
                      icon={faTrash}
                      title="Hapus event"
                      style={{ cursor: "pointer" }}
                      className="mr-2 x-close"
                      onClick={deleteById}
                    /> */}
                    
                     <FontAwesomeIcon
                        className="x-close"
                        icon={faXmark}
                        onClick={props.onHide}
                      />
                </div>
              </div>
            <hr/>
          <Modal.Body className="modal-body">
          <Form onSubmit={(e) => handleSubmit.mutate(e)}  >
    
            <div className="mt-2">
              <label className="label-form">Semester</label>
              <select
                aria-label="Default select example"
                name="ysb_semester_id"
                onChange={handleChange}
                value={form?.ysb_semester_id}
                className="select-form"
                disabled
              >
                <option value="" disabled>
                  {loadingTA ? "Memuat data..." : "Pilih Semester.."}
                </option>
                {getDataTA.map((row, index) => (
                  <option key={index} value={row?.id}>
                    {row?.name_year} (Semester {row?.semester})
                  </option>
                ))}
              </select>
            </div>

            <div className="mt-2" >
              <label className="label-form">Dimensi</label>
              <select
                  aria-label="Default select example"
                  name="ysb_dimensi_id"
                  onChange={handleChange}
                  value={form?.ysb_dimensi_id}
                  className="select-form"
                  disabled
              >
                <option value="" disabled>
                    {loadingDimensi ? "Memuat data..." : "Pilih Dimensi.."}
                </option>
                {getDataDimensi.map((row, index) => (
                  <option key={index} value={row?.id}>
                    {row.name_dimensi}
                  </option>
                ))}
              </select>
            </div>

            <div className="mt-2">
              <label className="label-form">Element</label>
              <select
                aria-label="Default select example"
                onChange={handleChange}
                name="ysb_element_id"
                value={form?.ysb_element_id}
                className="select-form"
                disabled
              >
                <option value="" disabled>
                  {!form?.ysb_dimensi_id
                    ? "Pilih dimensi dulu.."
                    : loadingElement
                    ? "Memuat data..."
                    : "Pilih Element.."}
                </option>
                {getElement.map((row, index) => (
                  <option key={index} value={row?.id}>
                    {row.description}
                  </option>
                ))}        
              </select>
            </div>

            <div className="mt-2">
              <label className="label-form">Indikator</label>

              <div className="custom-select-wrapper">
                <button
                disabled
                  type="button"
                  className="custom-select-trigger"
                  onClick={() => setOpenIndikator(!openIndikator)}
                  // disabled={!form?.ysb_element_id || loadingIndikator}
                >
                  {selectedIndikatorLabel ||
                    (!form?.ysb_element_id
                      ? "Pilih element dulu.."
                      : loadingIndikator
                      ? "Memuat data..."
                      : form.name_sub_element)}
                </button>

                {openIndikator && (
                  <div className="custom-select-dropdown">
                    {getIndikator.map((row, index) => (
                      <div
                        key={index}
                        className="custom-select-option"
                        onClick={() => {
                          setForm((prev) => ({
                            ...prev,
                            ysb_sub_element_id: row.id,
                          }));
                          setSelectedIndikatorLabel(row.description);
                          setOpenIndikator(false);
                        }}
                      >
                        {row.description}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <div className="input-group mt-4 label-group-form-area">
              <label className="label-name-form">Peilaku</label>
              <textarea
                className="form-control"
                name="description_anomaly"
                value={form.description_anomaly}
                onChange={handleChange}
                aria-label="With textarea"
              />
            </div>



            <div className="d-flex">
              <div className="ml-auto">
                <Button
                  className="mt-4 btn-modal-create"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <span>
                      <i className="fa fa-spinner fa-spin mr-2" />
                      Memperbarui...
                    </span>
                  ) : (
                    "Perbarui"
                  )}
                </Button>
              </div>
            </div>
          </Form>
            
        </Modal.Body>
    </Modal>

  </div>
    );
  }
